import React from 'react';
import styles from './GroupContextMenu.module.scss';
import { ReactComponent as Checked } from 'img/icon-checked.svg';
import BaseContextMenu from './BaseContextMenu';

export interface GroupContextMenuItem {
  label: string;
  onClick: () => void;
  icon?: React.ReactElement;
  isChecked?: boolean;
}

export interface GroupContextMenuGroup {
  items: GroupContextMenuItem[];
  groupName?: string;
  toggleEnabled?: boolean; 
  isToggled?: boolean;      
  onToggle?: () => void;    
}

export interface GroupContextMenuProps {
  groups: GroupContextMenuGroup[];
  onClose: () => void;
}

const GroupContextMenu: React.FC<GroupContextMenuProps> = ({ groups, onClose }) => {
  return (
    <BaseContextMenu onClose={onClose}>
      <div className={styles.menu} onClick={e => e.stopPropagation()}>
        {groups.map((group, gIndex) => (
          <div key={gIndex} className={styles.group}>
            <div className={styles.groupHeader}>
              {group.groupName && (
                <span className={styles.groupTitle}>{group.groupName}</span>
              )}
              
              {group.toggleEnabled && (
                <div
                  className={`${styles.toggleButton} ${
                    group.isToggled ? styles.active : ''
                  }`}
                  onClick={group.onToggle}
                >
                  {group.isToggled ? <Checked /> : <span className={styles.emptyCircle} />}
                </div>
              )}
            </div>

            <div className={styles.groupItems}>
              {group.items.map((item, iIndex) => (
                <div
                  key={iIndex}
                  className={styles.item}
                  onClick={() => {
                    item.onClick();
                    onClose(); 
                  }}
                >
                  {item.icon && <span className={styles.itemIcon}>{item.icon}</span>}
                  <span className={styles.itemLabel}>{item.label}</span>
                  {item.isChecked !== undefined && (
                    <span className={styles.itemChecked}>
                      {item.isChecked && <Checked />}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </BaseContextMenu>
  );
};

export default GroupContextMenu;
